import { SETTINGS_NAVIGATION as defaultValue } from "../../../config/settings-navigation";
import { useContext, useEffect, useCallback } from "react";
import { Link } from "uikit-react";
import { AppContexts } from "../../../providers";
import { useHistory, useLocation } from "react-router-dom";
import { usePermissionsStore } from "../../permissions/permissions_store";



const moduleFor = (key) => ({ chat: "messaging.chatbot", five_star: "messaging.surveys", smart_locks: "admin.integrations" }[key] || "admin.settings");

const SettingsNavbar = () => {
  const { get, active, setActive } = useContext(AppContexts.SettingsContext);
  const { user: account } = useContext(AppContexts.AuthContext);
  const history = useHistory();
  const location = useLocation();
  const { canView, permsLoaded } = usePermissionsStore();

  const allowed = useCallback((key) => permsLoaded && canView(moduleFor(key)), [permsLoaded, canView]);

  const canAccessSmartLocks = permsLoaded && canView("admin.integrations");

  const handleActiveList = (key) => {
    let val = defaultValue.find((v) => v.key === key);

    if (!allowed(key)) return;
    setActive(key);
    get(val.types);
    history.push(`/settings/${val.path}`);
  };

  const hasFlag = (flag) => {
    return !!account.flags.find((f) => f.name === flag);
  };

  useEffect(() => {
    let pathArray = location.pathname.split("/");
    let path = pathArray.pop().replace("#", "");
    let val = defaultValue.find((v) => v.path === path);

    if (!val) {
      if (!allowed(defaultValue[0].key)) return;
      setActive(defaultValue[0].key);
      get(defaultValue[0].types);
    } else {
      if (!allowed(val.key)) return;
      setActive(val.key);
      get(val.types);
    }
  }, [location.pathname, allowed, get, setActive]);

  return (
    <aside className="hms-section-nav-wrap uk-width-auto">
      <ul className="hms-section-nav">
        {allowed("branding") && (
        <li
          className={active === "branding" ? "is-active" : ""}
          onClick={() => handleActiveList("branding")}
        >
          <Link>Branding</Link>
        </li>
        )}
        {allowed("messages") && (
        <li
          className={active === "messages" ? "is-active" : ""}
          onClick={() => handleActiveList("messages")}
        >
          <Link>Messaging</Link>
        </li>
        )}
        {allowed("house_rules") && (
        <li
          className={active === "house_rules" ? "is-active" : ""}
          onClick={() => handleActiveList("house_rules")}
        >
          <Link>House Rules</Link>
        </li>
        )}
        {allowed("chat") && (
        <li
          className={active === "chat" ? "is-active" : ""}
          onClick={() => handleActiveList("chat")}
        >
          <Link>AI Chatbot & Text Webchat</Link>
        </li>
        )}
        {allowed("integrations") && (
        <li
          className={active === "integrations" ? "is-active" : ""}
          onClick={() => handleActiveList("integrations")}
        >
          <Link>Airbnb Integration</Link>
        </li>
        )}
        {allowed("tags") && (
        <li
          className={active === "tags" ? "is-active" : ""}
          onClick={() => handleActiveList("tags")}
        >
          <Link>Tags</Link>
        </li>
        )}
        {allowed("tag_groups") && (
        <li
          className={active === "tag_groups" ? "is-active" : ""}
          onClick={() => handleActiveList("tag_groups")}
        >
          <Link>Tag Groups</Link>
        </li>
        )}
        {allowed("five_star") && (
        <li
          className={active === "five_star" ? "is-active" : ""}
          onClick={() => handleActiveList("five_star")}
        >
          <Link>Five Star Review</Link>
        </li>
        )}
        {/*
        {allowed("holiday_schedule") && (
        <li
          className={active === "holiday_schedule" ? "is-active" : ""}
          onClick={() => handleActiveList("holiday_schedule")}
        >
          <Link>Holiday Schedule</Link>
        </li>
        )}
        {allowed("embed") && (
        <li
          className={active === "embed" ? "is-active" : ""}
          onClick={() => handleActiveList("embed")}
        >
          <Link>Embed</Link>
        </li>
        )}
         */}
        {canAccessSmartLocks && (
          <li
            className={active === "smart_locks" ? "is-active" : ""}
            onClick={() => handleActiveList("smart_locks")}
          >
            <Link>Smart Locks</Link>
          </li>
        )}
        {allowed("api") && (
        <li
          className={active === "api" ? "is-active" : ""}
          onClick={() => handleActiveList("api")}
        >
          <Link>API</Link>
        </li>
        )}
      </ul>
    </aside>
  );
};

export default SettingsNavbar;
